import { forwardRef } from 'react';
import Slider from 'react-slick';
// Types
import { GetMediaPosts_getMediaPosts_entities } from 'api/mediaPost/types/GetMediaPosts';
import { Settings } from 'react-slick';
// Components
import MediaFeedListItem from './MediaFeedListItem/MediaFeedListItem';
import Carousel from 'ui3/Carousel/Carousel';
// Styles
import styles from './MediaFeedList.module.scss';

const sliderSettings = {
  infinite: false,
  adaptiveHeight: false,
  speed: 500,
  swipeToSlide: true,
  variableWidth: true,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  centerPadding: '0px',
} as Settings;

type MediaFeedListProps = {
  mediaFeeds: GetMediaPosts_getMediaPosts_entities[];
  withCarousel?: boolean;
  beforeChange?: (current: number, next: number) => void;
};

const MediaFeedList = forwardRef<Slider, MediaFeedListProps>(
  ({ mediaFeeds, withCarousel, beforeChange }, ref) => {
    if (withCarousel) {
      const settings: Settings = beforeChange
        ? { ...sliderSettings, beforeChange }
        : sliderSettings;
      return (
        <div className={styles.rootCarousel}>
          <Carousel ref={ref} {...settings} className={styles.slider}>
            {mediaFeeds.map((item, index) => (
              <MediaFeedListItem
                key={item.id}
                mediaFeed={item}
                priorityImageLoading={index <= 1}
              />
            ))}
          </Carousel>
        </div>
      );
    }
    return (
      <ul className={styles.root}>
        {mediaFeeds.map((item, index) => (
          <li className={styles.listItem} key={item.id}>
            <MediaFeedListItem
              mediaFeed={item}
              priorityImageLoading={index <= 1}
            />
          </li>
        ))}
      </ul>
    );
  }
);

MediaFeedList.displayName = 'MediaFeedList';

export default MediaFeedList;
